<template>
  <div class="agent-page">
    <div class="page-header">
      <h2>模型广场</h2>
    </div>
    <div class="agent-content">
      <div class="agent-grid">
        <div class="agent-item" v-for="item in productList" :key="item.id">
          <div class="agent-image">
            <img :src="item.image" alt="" />
          </div>
          <div class="agent-info">
            <div class="agent-name">{{ item.title }}</div>
            <div class="agent-price">
              <strong>¥</strong> {{ item.billing_price }}/ {{ item.unit || '次' }}
            </div>
          </div>
          <div class="agent-actions">
            <button class="tech-btn primary" @click="showDetail(item)">
              <span class="btn-text">查看详细</span>
              <span class="btn-glow"></span>
            </button>
            <a class="tech-btn secondary" :href="apiDocUrl" target="_blank">
              <span class="btn-text">API文档</span>
              <span class="btn-glow"></span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="500px" center custom-class="agent-dialog">
      <div class="dialog-content">
        <div class="dialog-image">
          <img :src="currentItem.image" alt="" />
        </div>
        <div class="dialog-info">
          <h3 class="dialog-title">{{ currentItem.title }}</h3>
          <div class="dialog-price">
            <strong>¥</strong> {{ currentItem.billing_price }}/ {{ currentItem.unit || '次' }}
          </div>
          <p class="dialog-desc">{{ currentItem.description || '暂无详细描述' }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Agent',
  data() {
    return {
      productList: [],
      apiDocUrl: 'https://s.apifox.cn/99d32eb0-7b13-4b37-a95e-42d925207c46?pwd=123456',
      dialogVisible: false,
      currentItem: {}
    }
  },
  methods: {
    async getProductList() {
      try {
        const res = await this.$api.market.getProductList()
        if (res.code == 200) {
          this.productList = res.data || []
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },
    showDetail(item) {
      this.currentItem = item
      this.dialogVisible = true
    }
  },
  created() {
    this.getProductList()
  }
}
</script>

<style scoped>
.agent-page {
  padding: 24px;
  min-height: calc(100vh - 120px);
  background: linear-gradient(135deg, #f0f2ff 0%, #f5f7fa 50%, #f0f2ff 100%);
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 26px;
  font-weight: 700;
  background: linear-gradient(135deg, #5e60ce 0%, #7c7ff6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: 1px;
}

.agent-content {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 28px;
  box-shadow: 
    0 8px 32px rgba(94, 96, 206, 0.08),
    0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(94, 96, 206, 0.08);
}

.agent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 24px;
}

.agent-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 16px;
  cursor: pointer;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.9) 0%, rgba(245, 247, 250, 0.9) 100%);
  backdrop-filter: blur(10px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.agent-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 16px;
  padding: 1px;
  background: linear-gradient(135deg, rgba(94, 96, 206, 0.3), rgba(124, 127, 246, 0.1), rgba(94, 96, 206, 0.05));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.agent-item:hover {
  transform: translateY(-6px);
  box-shadow: 
    0 20px 40px rgba(94, 96, 206, 0.15),
    0 8px 16px rgba(94, 96, 206, 0.1),
    0 0 0 1px rgba(94, 96, 206, 0.1);
}

.agent-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(94, 96, 206, 0.08), transparent);
  transition: all 0.6s ease;
  pointer-events: none;
}

.agent-item:hover::after {
  left: 100%;
}

.agent-image {
  width: 88px;
  height: 88px;
  min-width: 88px;
  border-radius: 14px;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.05));
  box-shadow: 
    0 4px 12px rgba(94, 96, 206, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.5);
}

.agent-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.agent-item:hover .agent-image img {
  transform: scale(1.08);
}

.agent-info {
  flex: 1;
  padding: 0 20px;
  min-width: 0;
}

.agent-name {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.3px;
}

.agent-price {
  color: #5e60ce;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.5px;
}

.agent-price strong {
  font-weight: 600;
}

.agent-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.tech-btn {
  position: relative;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.tech-btn .btn-text {
  position: relative;
  z-index: 1;
}

.tech-btn .btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  transition: all 0.4s ease;
}

.tech-btn.primary {
  background: linear-gradient(135deg, #5e60ce 0%, #7c7ff6 100%);
  color: #fff;
  box-shadow: 
    0 4px 12px rgba(94, 96, 206, 0.35),
    0 2px 4px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.tech-btn.primary .btn-glow {
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
}

.tech-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 8px 20px rgba(94, 96, 206, 0.45),
    0 4px 8px rgba(0, 0, 0, 0.15);
}

.tech-btn.primary:hover .btn-glow {
  left: 100%;
}

.tech-btn.secondary {
  background: rgba(94, 96, 206, 0.08);
  color: #5e60ce;
  border: 1px solid rgba(94, 96, 206, 0.2);
}

.tech-btn.secondary .btn-glow {
  background: linear-gradient(90deg, transparent, rgba(94, 96, 206, 0.15), transparent);
}

.tech-btn.secondary:hover {
  background: rgba(94, 96, 206, 0.15);
  border-color: rgba(94, 96, 206, 0.4);
  color: #4a4ac8;
  transform: translateY(-2px);
}

.tech-btn.secondary:hover .btn-glow {
  left: 100%;
}

.tech-btn:active {
  transform: translateY(0);
}

.dialog-content {
  text-align: center;
}

.dialog-image {
  width: 140px;
  height: 140px;
  margin: 0 auto 24px;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.05));
  box-shadow: 
    0 8px 24px rgba(94, 96, 206, 0.2),
    inset 0 2px 4px rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(94, 96, 206, 0.1);
}

.dialog-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dialog-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 16px;
  letter-spacing: 0.5px;
}

.dialog-price {
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(135deg, #5e60ce 0%, #7c7ff6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 20px;
}

.dialog-price strong {
  font-weight: 600;
}

.dialog-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin: 0;
  padding: 16px;
  background: linear-gradient(135deg, rgba(94, 96, 206, 0.05), rgba(124, 127, 246, 0.02));
  border-radius: 12px;
  border: 1px solid rgba(94, 96, 206, 0.08);
}

.agent-dialog {
  border-radius: 20px !important;
  overflow: hidden;
}

.agent-dialog .el-dialog__header {
  padding: 20px 30px 0;
}

.agent-dialog .el-dialog__body {
  padding: 24px 30px 32px;
}
</style>
